import {usePrefetchQuery} from '@tanstack/react-query';
import {useSwiftRequisitesOptions} from '~/processes/fiat-operations/api/withdraw/swiftRequisites';
import {OperableAccount} from '~/redux/finances/domain';

export type SepaRequisitesPrefetcherProps = {
    account: OperableAccount;
};

export function WithdrawSwiftRequisitesPrefetcher({account}: SepaRequisitesPrefetcherProps) {
    usePrefetchQuery(useSwiftRequisitesOptions(account.id));
    return null;
}
